import React from 'react';

function ReservasPage() {
  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h2>Reservas Page (Deprecated)</h2>
      <p>This page is no longer in use. Please use the new booking flow.</p>
    </div>
  );
}

export default ReservasPage;